import {
  DefaultValues,
  FieldValues,
  FormProvider,
  useForm,
} from 'react-hook-form';

export function ContextForm<T extends FieldValues>({
  children,
  defaultValues,
  onSubmit,
}: {
  children: React.ReactNode;
  defaultValues: DefaultValues<T>;
  onSubmit: (values: T) => void;
}) {
  const methods = useForm<T>({
    defaultValues,
  });
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
    </FormProvider>
  );
}
